export const images = [
  {
    id: '01',
    src: '/The Yard 01.jpg',
    alt: 'The Yard',
  },
  {
    id: '02',
    src: '/The Yard 02.jpg',
    alt: 'The Yard',
  },
  {
    id: '03',
    src: '/The Yard 03.jpg',
    alt: 'The Yard',
  },
  {
    id: '04',
    src: '/The Yard 04.jpg',
    alt: 'The Yard',
  },
  {
    id: '05',
    src: '/The Yard 05.jpg',
    alt: 'The Yard',
  },
  {
    id: '06',
    src: '/The Yard 06.jpg',
    alt: 'The Yard',
  },
  {
    id: '07',
    src: '/The Yard 07.jpg',
    alt: 'The Yard',
  },
  {
    id: '08',
    src: '/The Yard 08.jpg',
    alt: 'The Yard',
  },
  {
    id: '09',
    src: '/The Yard 09.jpg',
    alt: 'The Yard',
  },
]
